// eslint-disable-next-line no-unused-vars
import TimeEntryAction from '@/constants/booking/timeEntries/TimeEntryAction'
import TimeEntryState from '@/constants/booking/timeEntries/TimeEntryState'

/**
 * Represents the status of a time entry, including current state,
 * booking ID, and available actions.
 */
export class TimeEntryStatusResponse {
  /**
   * Creates an instance of TimeEntryStatusResponse.
   * @param {Object} params - The parameters for initializing the model.
   * @param {number|null} params.bookingId - The booking ID, or null if not clocked in.
   * @param {keyof TimeEntryState} params.currentState - The current state of the shift.
   * @param {Array<keyof TimeEntryAction} params.availableActions - Actions available to the user.
   */
  constructor({
    bookingId = null,
    currentState = TimeEntryState.initial,
    availableActions = [],
  } = {}) {
    /**
     * The booking ID associated with the time entry.
     * @type {number|null}
     */
    this.bookingId = bookingId

    /**
     * The current state of the time entry.
     * @type {keyof TimeEntryState}
     */
    this.currentState = currentState

    /**
     * The list of actions currently available to the user.
     * @type {Array<keyof TimeEntryAction}
     */
    this.availableActions = this.processAvailableActions(
      currentState,
      availableActions
    )
  }

  /**
   * Processes actions list, modifying the list based on the current state
   *
   * @param {keyof TimeEntryState} currentState
   * @param {Array<keyof TimeEntryAction} availableActions
   * @returns {Array<keyof TimeEntryAction}
   */
  processAvailableActions(currentState, availableActions) {
    switch (currentState) {
      case TimeEntryState.onMealBreak:
        return this.processActionsWhileOnMealBreak(availableActions)
      default:
        return availableActions
    }
  }

  /**
   * Modifies the availableActions list to include the clock out button so it
   * can be rendered.
   *
   * The API does not return the clockOut action when currently on a meal break
   * which has necessitated this logic.
   *
   * @param {Array<keyof TimeEntryAction} availableActions
   * @returns {Array<keyof TimeEntryAction}
   */
  processActionsWhileOnMealBreak(availableActions) {
    if (availableActions.includes(TimeEntryAction.clockOut))
      return availableActions
    return [...availableActions, TimeEntryAction.clockOut]
  }
}
